module.exports = __webpack_public_path__ + "static/media/buying-guide.3ae5a66a.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/hero/buying-guide.jpeg
// module id = 1242
// module chunks = 0